import { AnnotationSystemContext } from '../AnnotationSystem.types';
import { REDUCER_INIT } from '../reducer';

export const CONTEXT_INIT: AnnotationSystemContext = [REDUCER_INIT, () => null];
